import { actions } from '@/store/modules/stay/smr/actions'
import { getters } from '@/store/modules/stay/smr/getters'
import { mutations } from '@/store/modules/stay/smr/mutations'
import { state } from '@/store/modules/stay/smr/state'

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true,
}